export const loadFont = async (fontFamilyName, url, options = {}, logError = true) => {
  let loadOk = false;
  try {
    // I.E doesn't support the FontFace API
    if (typeof FontFace === 'function') {
      const font = new FontFace(fontFamilyName, `url(${url})`, options);
      await font.load();
      document.fonts.add(font);
      document.body.classList.add('fonts-loaded');
      loadOk = true;
    }
  } catch (err) {
    if (logError) console.error(`Error loading font '${fontFamilyName}'`, err);
  }
  return loadOk;
};
